import React from 'react';
import { Navigate, Outlet, Route } from 'react-router-dom';
import AdminLayout from './components/AdminLayout';
import RolesPage from './components/RolesPage';
import UsersPage from './components/UsersPage';
import PermissionsPage from './components/PermissionsPage';
import { useMe } from '../../shared/hooks/useMe';

function AdminGuardLayout() {
  const { me, loading } = useMe();
  if (loading) return <div>Loading...</div>;
  if (!me?.can_manage_roles && !me?.can_manage_users) return <Navigate to="/forbidden" replace />;
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}

function RoleManagementGuard({ children }: { children: React.ReactNode }) {
  const { me } = useMe();
  return me?.can_manage_roles ? <>{children}</> : <Navigate to="/admin/users" replace />;
}

function UserManagementGuard({ children }: { children: React.ReactNode }) {
  const { me } = useMe();
  return me?.can_manage_users ? <>{children}</> : <Navigate to="/admin/roles" replace />;
}

/** Nested under AuthenticatedShell in App.tsx */
export const adminRoutes = (
  <Route path="admin" element={<AdminGuardLayout />}>
    <Route index element={<Navigate to="users" replace />} />
    <Route path="roles" element={<RoleManagementGuard><RolesPage /></RoleManagementGuard>} />
    <Route path="users" element={<UserManagementGuard><UsersPage /></UserManagementGuard>} />
    <Route path="permissions" element={<RoleManagementGuard><PermissionsPage /></RoleManagementGuard>} />
    <Route path="route-permissions" element={<Navigate to="/admin/roles" replace />} />
  </Route>
);

export default adminRoutes;
